import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { congThucTinhDiemApi } from "../../../api/category/congThucTinhDiemApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { ICongThucTinhDiem } from "../../../model/response/category/ICongThucTinhDiem";
import { eCongThucTinhDiemActionIds, ICongThucTinhDiemActionTypes } from "../../action-types/category/ICongThucTinhDiemActions";
import { lopTinChiApi } from "../../../api/tkb/lopTinChiApi";
import { congThucLopHocPhanApi } from "../../../api/category/congThucLopHocPhanApi";

const mainAction = rootActions.category.congThucTinhDiem;
export function* congThucTinhDiemSaga() {
    yield takeLatest(eCongThucTinhDiemActionIds.LOAD_START, loadWorker);
    yield takeEvery(eCongThucTinhDiemActionIds.SAVE_START, saveWorker);
    yield takeEvery(eCongThucTinhDiemActionIds.DELETE_START, deleteWorker);
    yield takeLatest(eCongThucTinhDiemActionIds.LOAD_LOP_TIN_CHI_START, loadLopTinChiWorker);
    yield takeLatest(eCongThucTinhDiemActionIds.SAVE_CONG_THUC_LOP_HOC_PHAN_START, saveCongThucLopHocPhanWorker);
}

function* loadWorker(): any {
    const res: IBaseResponse = yield call(congThucTinhDiemApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* saveWorker(action: ICongThucTinhDiemActionTypes): any {
    let res: IBaseResponse;
    const payload = action.payload as ICongThucTinhDiem;
    if (payload.id_cong_thuc > 0) {
        res = yield call(congThucTinhDiemApi.Update, payload.id_cong_thuc, payload);
    } else {
        res = yield call(congThucTinhDiemApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: ICongThucTinhDiemActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(congThucTinhDiemApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* loadLopTinChiWorker(action: ICongThucTinhDiemActionTypes): any {
    const payload = action.payload as { ky_dang_ky: number };
    const res: IBaseResponse = yield call(lopTinChiApi.SelectByKyDangKy, payload.ky_dang_ky);
    if (res.is_success) {
        yield put(mainAction.LOAD_LOP_TIN_CHI_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_LOP_TIN_CHI_ERROR(res.message ?? "Có lỗi"));
    }
}

function* saveCongThucLopHocPhanWorker(action: ICongThucTinhDiemActionTypes): any {
    const payload = action.payload as { ky_dang_ky: number, id_lop_tcs: number[] };
    const res: IBaseResponse = yield call(congThucLopHocPhanApi.SysAuto, payload.ky_dang_ky, payload.id_lop_tcs);
    if (res.is_success) {
        yield put(mainAction.SAVE_CONG_THUC_LOP_HOC_PHAN_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_CONG_THUC_LOP_HOC_PHAN_ERROR(res.message ?? "Có lỗi"));
    }
}